import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];
  const cellBase = {
    height: "52px !important",
    padding: "0 12px !important",
    boxSizing: "border-box" as const,
    border: "none !important",
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,
    fontSize: `${theme.typography.body2.fontSize} !important`,
    lineHeight: `${theme.typography.body2.lineHeight} !important`,
    textAlign: "right !important" as "right",
  };

  return {
    root: {
      width: "100%",
      backgroundColor: pageBackground,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      borderTop: "none",
      borderRight: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderLeft: `1px solid ${theme.palette.divider}`,
      overflow: "hidden",
      opacity: 1,
      "& > .MuiPaper-root": {
        width: "100%",
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "none",
      },
      "& .MuiTableContainer-root": {
        width: "100%",
        border: "none",
      },
      "& .MuiTable-root": {
        minWidth: 1400,
        tableLayout: "auto",
        borderCollapse: "collapse",
        border: "none",
        backgroundColor: `${pageBackground} !important`,
      },
      "& .MuiTableCell-root": {
        whiteSpace: "nowrap",
        borderLeft: "none !important",
        borderRight: "none !important",
      },
      "& .MuiTableHead-root": {
        opacity: 1,
      },
      "& .MuiTableHead-root .MuiTableRow-root": {
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        opacity: 1,
        backgroundColor: `${pageBackground} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead']": {
        ...cellBase,
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        opacity: "1 !important",
        borderTop: "none !important",
        borderLeft: "none !important",
        borderRight: "none !important",
        borderBottom: `1px solid ${theme.palette.divider} !important`,
        fontWeight: `${theme.typography.fontWeightMedium} !important`,
        backgroundColor: `${pageBackground} !important`,
        color: `${theme.palette.text.primary} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head:first-of-type": {
        borderTopLeftRadius: 4,
      },
      "& .MuiTableHead-root .MuiTableCell-head:last-of-type": {
        borderTopRightRadius: 4,
      },
      '&[dir="rtl"] .MuiTableHead-root .MuiTableCell-head:first-of-type, &[dir="rtl"] [class*="cellHead"]:first-of-type':
        {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 4,
        },
      '&[dir="rtl"] .MuiTableHead-root .MuiTableCell-head:last-of-type, &[dir="rtl"] [class*="cellHead"]:last-of-type':
        {
          borderTopRightRadius: 0,
          borderTopLeftRadius: 4,
        },
      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        opacity: 1,
        backgroundColor: `${theme.palette.background.paper} !important`,
        "&:hover, &:hover .MuiTableCell-root": {
          backgroundColor: `${theme.palette.background.tableRowHover} !important`,
        },
        "&:last-of-type .MuiTableCell-root:first-of-type": {
          borderBottomLeftRadius: 4,
        },
        "&:last-of-type .MuiTableCell-root:last-of-type": {
          borderBottomRightRadius: 4,
        },
      },
      '&[dir="rtl"] .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root:first-of-type':
        {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 4,
        },
      '&[dir="rtl"] .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root:last-of-type':
        {
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 4,
        },
      "& .MuiTableBody-root .MuiTableCell-root": {
        ...cellBase,
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        opacity: "1 !important",
        borderTop: "none !important",
        borderLeft: "none !important",
        borderRight: "none !important",
        borderBottom: `1px solid ${theme.palette.divider} !important`,
        fontWeight: `${theme.typography.fontWeightRegular} !important`,
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.secondary.main} !important`,
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root": {
        borderBottom: "none !important",
      },
    },
    textCell: {
      display: "inline-flex",
      justifyContent: "right",
      width: "100%",
    },
  };
});
